<template>
  <div class="article">
    <div class="inner-content" v-if="page.title.rendered">
      <Content
        class="article-content"
        :content="page.content_alt.content"
        v-if="page.content_alt && page.content_alt.content.length > 0"
      ></Content>

      <div class="article-content" v-html="page.content.rendered" v-else></div>
    </div>
  </div>
</template>

<script>
import Content from '@/components/Utils/Content.vue'

export default {
  name: 'Page',

  components: { Content },

  mounted () {
    this.$store.commit('setLoading', true)
    this.$store.dispatch('getPage', this.$route.path).then(() => {
      this.$store.commit('setLoading', false)
    }).catch(() => {
      this.$router.push('/404')
    })
  },

  computed: {
    page () {
      return this.$store.getters.page
    },
  },

  beforeRouteLeave (to, from, next) {
    this.$store.commit('clearHero')
    next()
  }
}
</script>
